import { render, staticRenderFns } from "./payPage.vue?vue&type=template&id=78dffcb3&scoped=true"
import script from "./payPage.vue?vue&type=script&lang=js"
export * from "./payPage.vue?vue&type=script&lang=js"
import style0 from "./payPage.vue?vue&type=style&index=0&id=78dffcb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dffcb3",
  null
  
)

export default component.exports